// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__NF","cls2":"ImpactHubModal-cls2_v1b ImpactHubModal-cls1__NF"};